import React from "react";
import { useSearchParams } from "react-router-dom";
import { Col, Container, Row, Spinner } from "react-bootstrap";

function PaymentInProgress() {
  const [searchParams] = useSearchParams();

  const paymentFormUrl = searchParams.get("paymentFormUrl");

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8} className="text-center">
          <Spinner animation="border" role="status" className="mb-3">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <h3>Plaćanje u tijeku...</h3>
          <p>
            Bit će te preumjereni na stranicu za plaćanje, molimo pričekajte.
            <br />
            {paymentFormUrl && (
              <>
                <span>Ako niste automatski preusmjereni, </span>
                <a href={paymentFormUrl} rel="noopener noreferrer">
                  kliknite ovdje
                </a>
              </>
            )}
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default PaymentInProgress;
